<template>
  <el-select v-model="bankCardValue" placeholder="请选择银行卡" @change="cardChange">
    <el-option :label="item.cardName" :value="item.moneyaccount +'-'+ item.channelid +'-'+item.depositacct + '-'+item.singledeallimit + '-'+item.singledaylimit + '-'+item.paycenterid" v-for="(item,i) in bankCardListChild" :key="i"></el-option>
  </el-select>
</template>

<script>
export default {
  name: "bankCardList",
  data () {
    return {
      bankCardValue: '',
      bankCardListChild: '',
    }
  },
  mounted () {
    this.getCardList()
  },
  methods: {
    getCardList () {
      this.$http.post(this.$apiPath.myBankList, {
        custno: this.$commonJs.getCookie('u_custno1'),
      }).then(res => {
        // console.log(res);
        if(res.data.code == 200) {
          const banklist = res.data.data
          var newBankList = new Array();
          for (var i = 0; i < banklist.length; i++) {
            if (banklist[i].flag == "1") {
              newBankList.unshift(banklist[i])
            } else {
              newBankList.push(banklist[i])
            }
            banklist[i].name = this.$commonJs.getBankName(banklist[i].channelid).split("-")[1]// 建设银行
            banklist[i].cardName = banklist[i].name + '[' + banklist[i].depositacctByConfusion + ']'
          }
          this.bankCardListChild = newBankList
          // moneyaccount  channelid  depositacct  hfsignresult汇付判断  singledeallimit  singledaylimit paycenterid 0206富友 0207汇付
          this.bankCardValue = this.bankCardListChild[0].moneyaccount + '-' + this.bankCardListChild[0].channelid + '-' + this.bankCardListChild[0].depositacct + '-' + this.bankCardListChild[0].singledeallimit + '-' + this.bankCardListChild[0].singledaylimit+ '-' + this.bankCardListChild[0].paycenterid
          window.sessionStorage.setItem('card', this.bankCardValue)
          this.$emit('func', this.bankCardValue)
        }
      }).catch(err => { })
    },
    cardChange (val) {
      this.$emit("slected", val)
    },

  }
}
</script>

<style lang="less" scoped>
</style>